export default __webpack_public_path__ + "static/media/cross.b5a28aa8.svg";